// extracted by mini-css-extract-plugin
export default {"primarybutton":"#db3d35","primarybuttontextcolor":"#fff","darkbackgroundcolor":"#000","white":"#fff"};